import { useEffect, useRef, useState } from "react";
import noDataFoundImage from "../assets/images/no-image-available-titleList.jpg"

export    const formatCurrency = (value: number, toFixed?: number, sign?:string) => {
  const priceisNaN = isNaN(Number(value))
  if(priceisNaN) return "-" 
  return (
    (value < 0 ? "(" : "") + (sign?.length ? sign === "noSign" ? "" : sign : "$") +
    Math.abs(Number(value))
        .toFixed(toFixed ?? 2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,")
        + (value < 0 ? ")" : "")
    );
  };

  export const formatCurrencyOne = (
  value: number,
  toFixed: number = 0,
  sign: string = ""
): string => {
  const numericValue = Number(value);

  if (isNaN(numericValue)) return "-";

  const isNegative = numericValue < 0;
  const absValue = Math.abs(numericValue);

  const formatted = absValue
    .toFixed(toFixed)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return `${isNegative ? "(" : ""}${sign}${formatted}${isNegative ? ")" : ""}`;
};


  export const formatValue =  (value: number) => {
    const priceisNaN = isNaN(Number(value))
    if(priceisNaN) return "-" 
    return (
      (value < 0 ? "(" : "") +
      Math.abs(Number(value))
          + (value < 0 ? ")" : "")
      );
    };
  
  export const downloadPdfData = (response: any) => {
    const blob = new Blob([response], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.download = 'document.pdf';
    link.href = URL.createObjectURL(blob);
    link.click();
    URL.revokeObjectURL(link.href);
  };


  export const base64ToBlobAndURL = async (base64Data: any) => {
    // Extract the content type and base64 data
    if(base64Data === 404 || base64Data === ""){
      const response = await fetch(noDataFoundImage);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      return url
    }
    const [metadata, data] = base64Data.split(',');
  
    // Safely match the metadata
    const match = metadata.match(/data:(.*);base64/);
    if (!match || !match[1]) {
      throw new Error('Invalid base64 data format');
    }
    const contentType = match[1];
  
    // Decode base64 string
    const byteCharacters = atob(data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
  
    // Create a Blob
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType });
  
    // Generate a URL for the Blob
    const blobURL = URL.createObjectURL(blob);
  
    return blobURL ;
  }
  

  /** API `dataAsOf` is YYYY-MM-DD; format as mm/dd/yyyy for POS section headers. */
  export const formatPosDataAsOf = (
    isoDate: string | null | undefined
  ): string => {
    if (!isoDate) return "";
    const dayPart = isoDate.split("T")[0];
    const [y, m, d] = dayPart.split("-");
    if (!y || !m || !d) return "";
    return `${m.padStart(2, "0")}/${d.padStart(2, "0")}/${y}`;
  };

  export const stripHTML = (html : any) => {
    console.log(html,"htmlhtmlhtml")
    return html.replace(/<\/?[^>]+(>|$)/g, "").trim();
  }


  export function debounceAsync(fn: (...args: any) => Promise<any>, delay = 500) {
    const timeoutId = useRef<NodeJS.Timeout | null>(null);
    const lastRequest = useRef<Promise<any> | null>(null);
  
    const debouncedFn = useRef(
      async (...args: any) => {
        if (timeoutId.current) {
          clearTimeout(timeoutId.current);
        }
  
        const currentRequest = new Promise((resolve, reject) => {
          timeoutId.current = setTimeout(async () => {
            try {
              const result = await fn(...args);
              lastRequest.current = result;
              resolve(result);
            } catch (error) {
              reject(error);
            }
          }, delay);
        });
  
        if (lastRequest.current) {
          return lastRequest.current;
        }
  
        return currentRequest;
      }
    );
  
    return debouncedFn.current;
  }
  